import { $generateHtmlFromNodes } from "@lexical/html";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { OnChangePlugin } from "@lexical/react/LexicalOnChangePlugin";
import { $getRoot } from "lexical";
import React from "react";
const CustomOnChangePlugin = ({ onChange, setContentLength, }) => {
    const [editor] = useLexicalComposerContext();
    const handleChange = (editorState) => {
        editorState.read(() => {
            const root = $getRoot();
            const textContent = root.getTextContent();
            setContentLength && setContentLength(textContent.length);
            // Generate HTML from the editor content
            const htmlString = $generateHtmlFromNodes(editor, null);
            // Call onChange callback if provided
            if (onChange) {
                onChange(htmlString);
            }
        });
    };
    return React.createElement(OnChangePlugin, { onChange: handleChange });
};
export default CustomOnChangePlugin;
//# sourceMappingURL=on-change-plugin.js.map